// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-content .modal-header {\n    justify-content: center;\n}\n.modal-content .modal-header .modal-title {\n    font-size: 25px;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
